import { OverlayRef } from '@angular/cdk/overlay';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { PopoverConfig } from './popover-config';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class PopoverRef<T = any> {
  private afterClosedSubject = new Subject<T>();
  public beforeCloseCallback: () => T;

  constructor(
    private overlayRef: OverlayRef,
    public config: PopoverConfig,
  ) {
    if (!config.disableClose) {
      this.overlayRef.backdropClick().subscribe(() => {
        const value = this.beforeCloseCallback ? this.beforeCloseCallback() : null;
        if (value) {
          this.close(value);
        } else {
          this.close();
        }
      });

      this.overlayRef
        .keydownEvents()
        .pipe(filter((event) => event.key === 'Escape'))
        .subscribe(() => {
          this.close();
        });
    }
  }

  public close(dialogResult?: T): void {
    this.afterClosedSubject.next(dialogResult);
    this.afterClosedSubject.complete();

    this.overlayRef.dispose();
  }

  public afterClosed(): Observable<T> {
    return this.afterClosedSubject.asObservable();
  }
}
